import { useCallback } from 'react';
import { actionBus, type ActionPayload, type ComponentKey } from '../services/action-bus';

export function useActionTrigger() {
	return useCallback((target: ComponentKey | ComponentKey[], payload?: ActionPayload) => {
		actionBus.trigger(target, payload);
	}, []);
}


